import React from "react";

const DeleteModal = ({ isOpen, toggleDeleteModal, deleteModal, nameParameter }) => {
    if (!isOpen) return null;
    let pronoun = 'este';
    if(nameParameter === 'simCard')
        pronoun = 'esta';
    return (
        <div className="flex fixed inset-0 z-0 items-center justify-center p-4 bg-gray-900 bg-opacity-80">
        <div className="w-full max-w-md bg-white rounded-lg shadow-lg">
            <div className="relative flex items-center p-4 text-blue-600">
            <button
                type="button"
                onClick={toggleDeleteModal}
                className="absolute top-0 right-0 mt-4 mr-4 hover:text-red-500 w-6 h-6"
            >
                <span className="material-icons text-2xl font-bold">close</span>
            </button>
            </div>

            <div className="p-4 text-black h-60 overflow-y-auto">
            <div className="text-center space-y-4">
                <span className="material-icons-outlined text-red-500 text-6xl">
                error_outline
                </span>
                <h3 className="text-xl text-black">
                ¿Deseas eliminar {pronoun} {nameParameter}
                </h3>

                <div className="flex justify-center space-x-4">
                <button
                    type="button"
                    onClick={deleteModal}
                    className="flex px-5 py-2.5 bg-blue-600 hover:bg-blue-800 text-white rounded-lg shadow-lg"
                >
                    <span className="material-icons-outlined mr-2">check</span> ¡Sí!
                </button>
                <button
                    type="button"
                    onClick={toggleDeleteModal}
                    className="flex px-5 py-2.5 bg-red-500 hover:bg-red-800 text-white rounded-lg shadow-lg"
                >
                    <span className="material-icons-outlined mr-2">close</span> ¡No!
                </button>
                </div>
            </div>
            </div>
        </div>
        </div>
    );
};

export default DeleteModal;
